// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QT4F","newExpiryDate":"styles_newExpiryDate__3MJ8L","footer":"styles_footer__KIwUG"};